import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale.service';

@Pipe({
  name: 'localeDate',
  standalone: false
})
export class LocaleDatePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(
    value: Date | string | number | null | undefined,
    format: 'date' | 'datetime' | 'datetime-dropdown' | 'time' | 'time-seconds' | 'short' | 'table-date' | 'table-datetime' = 'date'
  ): string {
    if (!value) return '';

    switch (format) {
      case 'datetime':
        return this.localeService.formatDateTime(value);
      case 'table-date':
        return this.localeService.formatTableDate(value);
      case 'table-datetime':
        return this.localeService.formatTableDateTime(value);
      case 'short':
        return this.localeService.formatDateShort(value);
      case 'time':
        return this.localeService.formatTime(value);
      case 'time-seconds':
        return this.localeService.formatTimeWithSeconds(value);
      case 'date':
      default:
        return this.localeService.formatDate(value);
    }
  }
}
